const state = {
    currency: null,
   
};

const getters = {
    GET_CURRENCY: (state) => {
        return state.currency;
    },
    
};


const actions = {

    CLEAR_C_PAYMENT_LIST_STORE: ({ commit }) => {
        commit('clearCPaymentListStore');
    },
    SET_CURRENCY: ({ commit }, curr) => {

        commit('saveCurrency', curr);

    },
    

};


const mutations = {
    clearCPaymentListStore: (state) => {
        state.currency = null;
        
       
    },

    saveCurrency: (state, curr) => {
        state.currency = curr;
    },
    

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}